import { createAction, props } from "@ngrx/store";
import { ProductResponseData, ComponentData, HardwareData, ProductData } from 'src/app/model/api/data-rest';
import {
	AddOrUpdateComponentRequest,
	AddOrUpdateHardwareRequest,
	CreateOrUpdateProductRequest,
} from 'src/app/conf/firmware-release';

// --- Product ---
export const getProducts = createAction('GET_PRODUCTS', props<{ name?: string; types?: string[] }>());
export const getProductsSuccess = createAction('GET_PRODUCTS_SUCCESS', props<{ productsResponseData: ProductResponseData }>());
export const getProductsFailed = createAction('GET_PRODUCTS_FAILED', props<{ errorMessage: string }>());

export const getProduct = createAction('GET_PRODUCT', props<{ productId: number }>());
export const getProductSuccess = createAction('GET_PRODUCT_SUCCESS', props<{ product: ProductData }>());
export const getProductFailed = createAction('GET_PRODUCT_FAILED', props<{ errorMessage: string }>());

export const createProduct = createAction('CREATE_PRODUCT', props<{ body: CreateOrUpdateProductRequest }>());
export const createProductSuccess = createAction('CREATE_PRODUCT_SUCCESS', props<{ product: ProductData }>());
export const createProductFailed = createAction('CREATE_PRODUCT_FAILED', props<{ errorMessage: string }>());

export const updateProduct = createAction('UPDATE_PRODUCT', props<{ productId: number; body: CreateOrUpdateProductRequest }>());
export const updateProductSuccess = createAction('UPDATE_PRODUCT_SUCCESS', props<{ product: ProductData }>());
export const updateProductFailed = createAction('UPDATE_PRODUCT_FAILED', props<{ errorMessage: string }>());

export const deleteProduct = createAction('DELETE_PRODUCT', props<{ productId: number }>());
export const deleteProductSuccess = createAction('DELETE_PRODUCT_SUCCESS', props<{ productId: number }>());
export const deleteProductFailed = createAction('DELETE_PRODUCT_FAILED', props<{ errorMessage: string }>());

// --- Hardware ---
export const getHardwareList = createAction('GET_HARDWARE_LIST', props<{ productId: number }>());
export const getHardwareListSuccess = createAction('GET_HARDWARE_LIST_SUCCESS', props<{ productId: number; hardware: HardwareData[] }>());
export const getHardwareListFailed = createAction('GET_HARDWARE_LIST_FAILED', props<{ productId: number; errorMessage: string }>());

export const createHardware = createAction('CREATE_HARDWARE', props<{ productId: number; body: AddOrUpdateHardwareRequest }>());
export const createHardwareSuccess = createAction('CREATE_HARDWARE_SUCCESS', props<{ productId: number; hardware: HardwareData }>());
export const createHardwareFailed = createAction('CREATE_HARDWARE_FAILED', props<{ errorMessage: string }>());

export const updateHardware = createAction('UPDATE_HARDWARE', props<{ productId: number; hardwareId: number; body: AddOrUpdateHardwareRequest }>());
export const updateHardwareSuccess = createAction('UPDATE_HARDWARE_SUCCESS', props<{ productId: number; hardware: HardwareData }>());
export const updateHardwareFailed = createAction('UPDATE_HARDWARE_FAILED', props<{ errorMessage: string }>());

export const deleteHardware = createAction('DELETE_HARDWARE', props<{ productId: number; hardwareId: number }>());
export const deleteHardwareSuccess = createAction('DELETE_HARDWARE_SUCCESS', props<{ productId: number; hardwareId: number }>());
export const deleteHardwareFailed = createAction('DELETE_HARDWARE_FAILED', props<{ errorMessage: string }>());

// --- Component ---
export const getComponents = createAction('GET_COMPONENTS', props<{ hardwareId: number }>());
export const getComponentsSuccess = createAction('GET_COMPONENTS_SUCCESS', props<{ hardwareId: number; components: ComponentData[] }>());
export const getComponentsFailed = createAction('GET_COMPONENTS_FAILED', props<{ hardwareId: number; errorMessage: string }>());

export const createComponent = createAction('CREATE_COMPONENT', props<{ hardwareId: number; body: AddOrUpdateComponentRequest }>());
export const createComponentSuccess = createAction('CREATE_COMPONENT_SUCCESS', props<{ hardwareId: number; component: ComponentData }>());
export const createComponentFailed = createAction('CREATE_COMPONENT_FAILED', props<{ errorMessage: string }>());

export const updateComponent = createAction('UPDATE_COMPONENT', props<{ hardwareId: number; componentId: number; body: AddOrUpdateComponentRequest }>());
export const updateComponentSuccess = createAction('UPDATE_COMPONENT_SUCCESS', props<{ hardwareId: number; component: ComponentData }>());
export const updateComponentFailed = createAction('UPDATE_COMPONENT_FAILED', props<{ errorMessage: string }>());

export const deleteComponent = createAction('DELETE_COMPONENT', props<{ hardwareId: number; componentId: number }>());
export const deleteComponentSuccess = createAction('DELETE_COMPONENT_SUCCESS', props<{ hardwareId: number; componentId: number }>());
export const deleteComponentFailed = createAction('DELETE_COMPONENT_FAILED', props<{ errorMessage: string }>());

// --- Release artifact ---
export const uploadReleaseArtifact = createAction(
	'UPLOAD_RELEASE_ARTIFACT',
	props<{ softwareReleaseId: number; file: File }>(),
);
export const uploadReleaseArtifactSuccess = createAction(
	'UPLOAD_RELEASE_ARTIFACT_SUCCESS',
	props<{ softwareReleaseId: number; message: string }>(),
);
export const uploadReleaseArtifactFailed = createAction(
	'UPLOAD_RELEASE_ARTIFACT_FAILED',
	props<{ softwareReleaseId: number; errorMessage: string }>(),
);
